import React from "react";
import { Link } from "react-router-dom";
import Team_01 from '../../../assets/images/team/team-1.png';
import Team_02 from '../../../assets/images/team/team-4.png';
import Team_03 from '../../../assets/images/team/team-2.png';
import Team_04 from '../../../assets/images/team/team-5.png';
import Team_05 from '../../../assets/images/team/team-3.png';
import Team_1  from '../../../assets/images/svg/header/Fb.svg';
import Team_2  from '../../../assets/images/svg/header/Twiter.svg';
import Team_3  from '../../../assets/images/svg/header/Insta.svg';
import Team_4  from '../../../assets/images/svg/header/Pintrest.svg';


const Teamone = () => {
    return (
        <div className="team-section-one about-team">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 m-auto">
                        <div className="heading-box text-center">
                            <span
                                className="sub-title animate fadeInUp wow"
                                data-wow-duration="1500ms"
                            >
                                Team
                            </span>
                            <h2
                                className="heading-title animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                Our Team of Dedicated Digital Professionals{" "}
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center gutter-y-60">
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="team-box-one animate fadeInUp wow"
                            data-wow-duration="1500ms"
                        >
                            <div className="team-image-one">
                                <Link to="/Team">
                                    <img src={Team_01} alt="team-image" />
                                </Link>
                            </div>
                            <div className="team-details-one">
                                <h4>
                                    <Link to="/Team">Alex Jason</Link>
                                </h4>
                                <p>Finance consultant</p>
                            </div>
                            <ul className="team-social-media-one">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <img src={Team_1} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={Team_2} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={Team_3} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={Team_4} alt="icon" />
                                    </Link>
                                </li>
                            </ul >
                        </div >
                    </div >
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="team-box-one animate fadeInUp wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="400ms"
                        >
                            <div className="team-image-one">
                                <Link to="/Team">
                                    <img src={Team_02} alt="team-image" />
                                </Link>
                            </div>
                            <div className="team-details-one">
                                <h4>
                                    <Link to="/Team">Martin Doe</Link>
                                </h4>
                                <p>Sale Director</p>
                            </div>
                            <ul className="team-social-media-one">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <img src={Team_1} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={Team_2} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={Team_3} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={Team_4} alt="icon" />
                                    </Link>
                                </li >
                            </ul >
                        </div >
                    </div >
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="team-box-one animate fadeInUp wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="600ms"
                        >
                            <div className="team-image-one">
                                <Link to="/Team">
                                    <img src={Team_05} alt="team-image" />
                                </Link>
                            </div>
                            <div className="team-details-one">
                                <h4>
                                    <Link to="/Team">Richard Divas</Link>
                                </h4>
                                <p>Business Advisor</p>
                            </div>
                            <ul className="team-social-media-one">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <img src={Team_1} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={Team_2} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={Team_3} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={Team_4} alt="icon" />
                                    </Link>
                                </li >
                            </ul >
                        </div >
                    </div >
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="team-box-one animate fadeInUp wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="800ms"
                        >
                            <div className="team-image-one">
                                <Link to="/Team">
                                    <img src={Team_04} alt="team-image" />
                                </Link>
                            </div>
                            <div className="team-details-one">
                                <h4>
                                    <Link to="/Team">Monalis</Link>
                                </h4>
                                <p>Manager</p>
                            </div>
                            <ul className="team-social-media-one">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <img src={Team_1} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={Team_2} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={Team_3} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={Team_4} alt="icon" />
                                    </Link>
                                </li >
                            </ul >
                        </div >
                    </div >
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="team-box-one animate fadeInUp wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="1000ms"
                        >
                            <div className="team-image-one">
                                <Link to="/Team">
                                    <img src={Team_03} alt="team-image" />
                                </Link>
                            </div>
                            <div className="team-details-one">
                                <h4>
                                    <Link to="/Team">Sarah Hanley</Link>
                                </h4>
                                <p>Product Manager</p>
                            </div>
                            <ul className="team-social-media-one">
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <img src={Team_1} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={Team_2} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={Team_3} alt="icon" />
                                    </Link>
                                </li >
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={Team_4} alt="icon" />
                                    </Link>
                                </li >
                            </ul >
                        </div >
                    </div >
                </div >
            </div >
        </div >

    )
}
export default Teamone;